import React from 'react';

import withGooglePlaces from 'dpl/decorators/withGooglePlaces';

import LocationAutocomplete from '../components/LocationAutocomplete';

function LocationAutocompleteContainer(props) {
  return <LocationAutocomplete {...props} />;
}

export default withGooglePlaces(LocationAutocompleteContainer);
